module.exports = __webpack_public_path__ + "assets/img/home10.20351f0b.png";